import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const POWER_DEFAULT_UNIT = 'W' as const;

const units = ['W', 'kW', 'MW'] as const;
const unit = z.literal(POWER_DEFAULT_UNIT).default(POWER_DEFAULT_UNIT);

const validator = AbstractMeasurement.nomMax
    .extend({
        unit,
    })
    .default({});

const validators = {
    value: AbstractMeasurement.value
        .extend({
            unit,
        })
        .default({}),
    unit,
    nomMax: AbstractMeasurement.nomMax
        .extend({
            unit,
        })
        .default({}),
};

export const Power = {
    validator,
    validators,
    units,
    defaultUnit: POWER_DEFAULT_UNIT,
};

export type Power = z.infer<typeof validator>;
